import { FC, useState, ReactNode, Children } from "react";
import { Menu, ThemeProvider, styled } from "@mui/material";
import useSettings from "../../hooks/useSettings";

interface ProfileMenuProps {
  menuButton: ReactNode;
  shouldCloseOnItemClick?: boolean;
  horizontalPosition?: "left" | "center" | "right";
  children?: ReactNode;
}

const ProfileMenuButton = styled("div")(({ theme }) => ({
  display: "inline-block",
  color: theme.palette.text.primary,
  "& div:hover": { backgroundColor: theme.palette.action.hover }
}));

const ProfileMenu: FC<ProfileMenuProps> = ({
  menuButton,
  shouldCloseOnItemClick = true,
  horizontalPosition = "left",
  children
}) => {
  const { settings } = useSettings();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleProfileMenuClose = (): void => {
    setAnchorEl(null);
  }

  const handleProfileMenuClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const childrenArray = Children.toArray(children);

  return (
    <>
      <ProfileMenuButton onClick={handleProfileMenuClick}>{menuButton}</ProfileMenuButton>
      <ThemeProvider theme={settings.themes[settings.activeTheme]}>
        <Menu
          elevation={8}
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={handleProfileMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: horizontalPosition }}
          transformOrigin={{ vertical: "top", horizontal: horizontalPosition }}
        >
          {childrenArray.map((child, index) => (
            <div onClick={shouldCloseOnItemClick ? handleProfileMenuClose : () => { }} key={index}>
              {child}
            </div>
          ))}
        </Menu>
      </ThemeProvider>
    </>
  );
};

export default ProfileMenu;